import {
  Box,
  Button,
  getThemeColor,
  Icon,
  Text,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import * as Styles from './header-information-item.styles'
import { HeaderInformationItemProps } from './header-information-item.types'

export const HeaderInformationItem = ({
  label,
  value,
  icon,
  iconColor,
  url,
  seeMore,
  ...props
}: HeaderInformationItemProps) => {
  const theme = useTheme()

  return (
    <Box gap={2} alignItems="center" {...props}>
      <Box
        border={{
          width: 1,
          color: getThemeColor('grey_5', theme),
        }}
        justifyContent="center"
        alignItems="center"
        borderRadius="10px"
        width="50px"
        height="50px"
        boxShadow={theme.box_shadow.card}
      >
        <Icon name={icon} color={getThemeColor(iconColor, theme)} size={28} />
      </Box>
      <Styles.InformationColumn justifyContent="center" direction="column">
        <Box gap={1} alignItems="center">
          <Text color="grey_3" size="small" fontWeight={400}>
            {label}
          </Text>

          {seeMore && (
            <Button variant="text" padding="0" onClick={seeMore}>
              <Icon name="add_box" color="secondary" size={20} />
            </Button>
          )}
          {url && (
            <a href={url} target="_blank">
              <Icon name="arrow_right_up" color="secondary" size={20} />
            </a>
          )}
        </Box>
        {value && <Text fontWeight={500}>{value}</Text>}
      </Styles.InformationColumn>
    </Box>
  )
}
